import { apiUrl } from "../utils/api";

const urlLocationsInfo = "/wp-json/v2/nearby";

export const getLocationsInfo = (ids) =>
  $.ajax({
    method: "GET",
    url: apiUrl(urlLocationsInfo),
    data: {
      ids,
    },
  });
